module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/passthrough.js
// module id = 390
// module chunks = 10 11 12 13 14 15 16 17 18